import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import currencyUtils from 'utils/currency';
import objectUtils from 'utils/object';
import jsonUtils from 'utils/json';
import { orderPlacedMessage } from 'utils/orderConfirmation';
import {
  getStripeConfig,
  getRealexConfig,
  resizeRealexForm,
  loopCheckingPaymentResponse,
  checkoutResetState,
  closeModalError,
  openModalError,
  openModalReceipt,
  closeModalPlaceOrderAndRedirect,
  closeModalReceiptAndRedirect,
} from 'actions/Checkout';
import Stripe from '././Stripe/index';
import ModalReceipt from 'components/UI/Modal/ModalReceipt';
import ModalSuccessPayment from 'components/UI/Modal/ModalSuccessPayment';
import ModalError from 'components/UI/Modal/ModalError';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './checkout.scss';
import { ERROR_CODES, errorCopy } from 'utils/userError';

// Stripe sent the customer back with a failed payment (iDEAL, Bancontact, 3-D Secure).
const PAYMENT_NOT_COMPLETED_ERROR = errorCopy(ERROR_CODES.PAYMENT_DECLINED, {
  title: "Your payment didn't go through",
  message: 'The payment was not completed, so this order is not confirmed.',
  guidance: 'Try again, or choose another payment method.',
});

const RenderDiscount = props => {
  const classes = `flex flex-justify-space-between ${props.className}`;
  return !!props.value && props.forCollection === 'Y' ? (
    <div className={classes}>
      <p>{props.name}</p>
      <p>{`${props.value}`}</p>
    </div>
  ) : null;
};

const RenderValueLines = props => {
  const classes = `flex flex-justify-space-between ${props.className}`;
  return !!props.value ? (
    <div className={classes}>
      <p>{props.name}</p>
      <p>{`${props.currency} ${Number(props.value).toFixed(2)}`}</p>
    </div>
  ) : null;
};

const HeaderCheckout = props => {
  return props.isInvoice ? (
    <h4>Invoice </h4>
  ) : props.isForCollection === 'Y' ? (
    <h4>For collection</h4>
  ) : (
    <h4>For delivery</h4>
  );
};

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitted: false,
      returnStripeSucess: false,
      returnStripeFail: false,
    };

    this.formReference = React.createRef();
    this.renderProductsOnCart = this.renderProductsOnCart.bind(this);
    this.getCurrency = this.getCurrency.bind(this);
    this.eventFunction = this.eventFunction.bind(this);
    this.initStripePayment = this.initStripePayment.bind(this);
    this.tryPaymentAgain = this.tryPaymentAgain.bind(this);

    if (!!this.getOrderId()) {
      this.initStripePayment();
    }
  }

  getCartItensFromTeamVouchers = () => {
    if (!!this.props.teamVoucherOrder.orderItems) {
      return {
        idOrder: this.props.teamVoucherOrder.idOrder,
        publicOrderNumber: this.props.teamVoucherOrder.publicOrderNumber,
        products: this.props.teamVoucherOrder.orderItems.map(
          item => item.product
        ),
      };
    }
    return this.props.cart;
  };

  getProducts = () => {
    if (this.props.cart.products.length > 0) {
      return this.props.cart.products;
    }
    return this.getCartItensFromTeamVouchers().products;
  };

  getCollectionDiscount = () => {
    let campaignRateCollection = objectUtils.get(
      this.props,
      'cart.campaignRateCollection',
      null
    );
    if (campaignRateCollection) {
      let collectionDiscount =
        campaignRateCollection.discountType === 'P'
          ? `% ${campaignRateCollection.amount}`
          : `- ${campaignRateCollection.amount}`;
      return collectionDiscount;
    } else {
      return '';
    }
  };

  isForCollection = () => {
    return objectUtils.get(
      this.props,
      'cart.restaurantSelected.forCollection',
      'N'
    );
  };

  getReceiptData() {
    return {
      cart: this.getCartItensFromTeamVouchers(),
      total: this.getAmount(),
      currency: this.getCurrency(),
      surcharge: this.getSurcharge(),
      subtotal: this.getSubTotal(),
      taxDelivery: this.getTaxDelivery(),
      userDetails: this.props.userDetails,
      orderDeliveryDate: this.props.cart.orderDeliveryDate,
      collectionDiscount: this.getCollectionDiscount(),
      forCollection: this.isForCollection(),
      address: this.getAddress(),
      tipValue: this.getTipValue(),
      isVoucher: !this.props.teamVoucherOrder,
    };
  }

  componentWillUnmount(props) {
    this.props.checkoutResetState();
    this.removeEvent();
  }

  componentWillMount(props) {
    if (
      !!this.props &&
      !!this.props.location.search &&
      this.props.location.search.indexOf('succeeded') !== -1
    ) {
      this.setState({
        returnStripeSucess: true,
      });
      return;
    } else if (
      !!this.props &&
      !!this.props.location.search &&
      this.props.location.search.indexOf('failed') !== -1
    ) {
      this.setState({
        returnStripeFail: true,
      });
      return;
    } else {
      if (!this.getOrderId()) {
        this.props.history.replace('/Menu');
      }
    }
  }

  componentDidUpdate() {
    if (
      !this.state.isSubmitted &&
      !!this.props.stripeData.urlStripe &&
      !!this.formReference.current
    ) {
      this.addEvent();
      this.setState({
        isSubmitted: true,
      });
    }
  }

  tryPaymentAgain() {
    this.setState({
      isSubmitted: false,
    });
    this.props.history.replace('/Menu/Dynamic');
  }

  getTipValue = () => {
    return objectUtils.get(this.props, 'cart.tipValue', 0);
  };
  getAmount() {
    if (this.getIsInvoice()) {
      return this.props.invoice.total;
    } else {
      let totalCart = objectUtils.get(this.props, 'cart.subtotal', 0);
      let forCollection = objectUtils.get(
        this.props,
        'cart.restaurantSelected.forCollection',
        'N'
      );
      if (forCollection === 'Y') {
        const discountCollection = objectUtils.get(
          this.props,
          'cart.campaignRateCollection.amount',
          0
        );
        totalCart -= totalCart * (discountCollection / 100);
      } else {
        const subsidy = objectUtils.get(this.props, 'cart.subsidy', 0);
        totalCart -= subsidy;
      }
      totalCart =
        totalCart +
        objectUtils.get(this.props, 'cart.campaignRateCC.amount', 0);
      const totalFromTeamVoucher = objectUtils.get(
        this.props,
        'teamVoucherPayInfo.amount',
        0
      );
      totalCart = totalCart + objectUtils.get(this.props, 'cart.tipValue', 0);
      return !!totalCart ? totalCart : totalFromTeamVoucher;
    }
  }

  getSubTotal() {
    const subTotalFromCart = objectUtils.get(
      this.props,
      'cart.subtotal',
      undefined
    );
    const subTotalFromTeamVoucher = objectUtils.get(
      this.props,
      'teamVoucherOrder.totalAmount',
      0
    );
    return !!subTotalFromCart ? subTotalFromCart : subTotalFromTeamVoucher;
  }

  getOrderId() {
    if (this.getIsInvoice()) {
      return this.props.invoice.invoiceNumber;
    } else {
      const idFromCart = objectUtils.get(this.props, 'cart.idOrder', undefined);
      const idFromTeamVoucher = objectUtils.get(
        this.props,
        'teamVoucherOrder.idOrder',
        undefined
      );
      return !!idFromCart ? idFromCart : idFromTeamVoucher;
    }
  }

  getBusinessRestaurantId() {
    if (this.getIsInvoice()) {
      return 0;
    } else {
      const idFromCart = objectUtils.get(
        this.props,
        'cart.restaurantSelected.id',
        undefined
      );
      const idFromTeamVoucher = objectUtils.get(
        this.props,
        'teamVoucherOrder.idBusinessRestaurant',
        undefined
      );
      return !!idFromCart ? idFromCart : idFromTeamVoucher;
    }
  }

  getIsInvoice = () => {
    return objectUtils.get(this.props, 'cart.isInvoice');
  };

  getAddress = () => {
    return this.props.addresses[0];
  };

  removePayInfo() {
    localStorage.removeItem('PayInfo');
  }

  setPayInfo() {
    localStorage.setItem('PayInfo', JSON.stringify(this.getReceiptData()));
  }

  getPayInfo() {
    JSON.parse(localStorage.getItem('payInfo'));
    var payInfo = JSON.parse(localStorage.getItem('payInfo'));

    this.removePayInfo();

    return payInfo;
  }

  initStripePayment() {
    this.setPayInfo();

    if (!!this.props.showModalError) {
      this.props.openModalError();
    }
    const currency = this.getIsInvoice()
      ? this.props.invoice.currency
      : objectUtils.get(this.props, 'cart.restaurantSelected.currency', 'EUR');

    const payType =
      !!this.props.cart && !!this.props.cart.payInfo
        ? this.props.cart.payInfo.payType
        : !!this.props.teamVoucherPayInfo &&
          !!this.props.teamVoucherPayInfo.payType
        ? this.props.teamVoucherPayInfo.payType
        : 'C';

    const requestConfigDTO = {
      idBusinessRestaurant: this.getBusinessRestaurantId(),
      idOrder: this.getOrderId(),
      currency,
      amount: this.getAmount(),
      payType: payType,
    };

    this.props.getStripeConfig(requestConfigDTO);
  }

  eventFunction(message) {
    const messageIsFromRealexOrigin =
      !!this.props.stripeData.urlStripe &&
      this.props.stripeData.urlStripe.startsWith(message.origin);

    const messageData =
      jsonUtils.isValid(message.data) && JSON.parse(message.data);

    if (!messageIsFromRealexOrigin) return;

    const loopCheckingPaymentResponseIsValid =
      jsonUtils.isValid(message.data) &&
      messageData.message &&
      messageData.message.payload &&
      messageData.message.payload.nonce &&
      messageData.message.payload.response &&
      messageData.message.payload.response.object &&
      `${messageData.message.payload.response.object.status}`.startsWith(
        'succeeded'
      ) &&
      `${messageData.message.payload.response.object.object}`.startsWith(
        'payment_intent'
      ) &&
      !`${messageData.message.payload.response.type}`.startsWith('error');

    if (loopCheckingPaymentResponseIsValid) {
      this.props.loopCheckingPaymentResponse({
        messageRealex: message.data,
        isInvoice: this.getIsInvoice(),
        idOrder: this.getOrderId(),
        payInfo: {
          ...objectUtils.get(this.props, 'cart', {}),
          publicOrderNumber:
            objectUtils.get(this.props, 'cart.publicOrderNumber', undefined) ||
            objectUtils.get(this.props, 'teamVoucherOrder.publicOrderNumber', undefined),
        },
      });
    }
  }

  addEvent() {
    window.addEventListener('message', this.eventFunction);
  }

  removeEvent() {
    window.removeEventListener('message', this.eventFunction);
  }

  getCurrency() {
    if (!!this.props.cart.restaurantSelected && !!!this.getIsInvoice()) {
      return currencyUtils.convertNameToSymbol(
        objectUtils.get(this.props, 'cart.restaurantSelected.currency', 'EUR')
      );
    } else if (this.getIsInvoice()) {
      return currencyUtils.convertNameToSymbol(
        this.props.invoice.currency,
        'EUR'
      );
    } else {
      return '€';
    }
  }

  renderProductsOnCart = (product, index) => {
    return (
      <div key={'item' + index} className="item">
        <div className="flex flex-justify-space-between">
          <h3>{product.name}</h3>
          <h3>{this.getCurrency() + product.price.toFixed(2)}</h3>
        </div>
        <p>{product.description}</p>
      </div>
    );
  };

  renderHideInputsStripeForm() {
    var currency = localStorage.getItem('currency');

    var stripePromise =
      currency === 'USD'
        ? loadStripe(
            'pk_live_51Kgm5jBvVgLKLmZVA2xa3j1x2C2s7tj49lOHoaihe9m7Skce5mowr1VUwKkZgr7zBcUb1UGVZxIYcrpEFgFwCxCF00N5Z32Y5j'
          )
        : loadStripe('pk_live_4U4PYH6Q22nWYMstPtAFawvr');

    return !!this.props.stripeData.urlStripe ? (
      <Elements stripe={stripePromise}>
        <Stripe props={this.props} formReference={this.formReference} />
      </Elements>
    ) : null;
  }

  getTaxDelivery = () => {
    return !!this.props.restaurantSelected &&
      this.props.restaurantSelected.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantSelected.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getSurcharge = () => {
    const amountFromTeamVoucher = objectUtils.get(
      this.props,
      'teamVoucherCampaignRateCC.amount',
      undefined
    );
    const amountFromCart = objectUtils.get(
      this.props,
      'cart.campaignRateCC.amount',
      0
    );
    return !!amountFromTeamVoucher ? amountFromTeamVoucher : amountFromCart;
  };

  getCollectionDiscount = () => {
    let campaignRateCollection = objectUtils.get(
      this.props,
      'cart.campaignRateCollection',
      null
    );
    if (campaignRateCollection) {
      let collectionDiscount =
        campaignRateCollection.discountType === 'P'
          ? `% ${campaignRateCollection.amount}`
          : `- ${campaignRateCollection.amount}`;
      return collectionDiscount;
    } else {
      return '';
    }
  };

  isForCollection = () => {
    return !!this.props.cart.restaurantSelected
      ? objectUtils.get(
          this.props,
          'cart.restaurantSelected.forCollection',
          'N'
        )
      : 'N';
  };

  render() {
    const currency = this.getCurrency();
    return (
      <div className="checkout">
        <ModalSuccessPayment
          descriptionSuccess={
            orderPlacedMessage(
              JSON.parse(localStorage.getItem('PayInfo')).cart.publicOrderNumber
            )
          }
          isInvoice={JSON.parse(localStorage.getItem('PayInfo')).cart.isInvoice}
          showModal={
            this.state.returnStripeSucess
              ? this.state.returnStripeSucess
              : this.props.showModalPlaceOrder
          }
          closeModal={() =>
            this.props.closeModalPlaceOrderAndRedirect(this.props.history)
          }
          openReceipt={() => this.props.openModalReceipt()}
        />
        <ModalReceipt
          showModal={this.props.showModalReceipt}
          closeModal={() =>
            this.props.closeModalReceiptAndRedirect(this.props.history)
          }
          data={JSON.parse(localStorage.getItem('PayInfo'))}
        />
        <ModalError
          style={{ zIndex: '99999', position: 'absolute', margin: '5% 26%' }}
          showModal={
            this.state.returnStripeFail
              ? this.state.returnStripeFail
              : this.props.showModalError
          }
          closeModal={() => this.props.closeModalError(this.props.history)}
          errorMessage={
            (!this.state.returnStripeFail && this.props.messageError) ||
            PAYMENT_NOT_COMPLETED_ERROR
          }
          actionButton={this.tryPaymentAgain}
          actionButtonTitle="Try again"
        />
        <div className="cart-page">
          <h2>Payment</h2>
          <HeaderCheckout
            isInvoice={this.getIsInvoice()}
            isForCollection={this.isForCollection()}
          />
          <div className="items">
            {this.getProducts().map(this.renderProductsOnCart)}
          </div>
          <div className="total-items">
            <RenderValueLines
              name="Sub Total"
              currency={currency}
              value={this.getSubTotal()}
            />
            <RenderValueLines
              name="Subsidy"
              currency={currency}
              value={this.props.cart.subsidy}
            />
            <RenderValueLines
              name="Tip"
              currency={currency}
              value={this.getTipValue()}
            />
            <RenderValueLines
              name="Tax Delivery"
              currency={currency}
              value={this.getTaxDelivery()}
            />
            <RenderDiscount
              name="Collection Discount"
              forCollection={this.isForCollection()}
              currency={currency}
              value={this.getCollectionDiscount()}
            />
            <RenderValueLines
              name="Surcharge"
              currency={currency}
              value={this.getSurcharge()}
            />
            <RenderValueLines
              className="total"
              name="Total"
              currency={currency}
              value={this.getAmount()}
            />
          </div>
          {this.renderHideInputsStripeForm()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cartReducer.cart,
    invoice: state.invoiceReducer.invoice,
    realexData: state.checkoutReducer.realex,
    stripeData: state.checkoutReducer.stripe,
    showModalReceipt: state.checkoutReducer.showModalReceipt,
    showModalError: state.checkoutReducer.showModalError,
    showModalPlaceOrder: state.checkoutReducer.showModalPlaceOrder,
    messageSuccess: state.checkoutReducer.messageSuccess,
    userDetails: state.authenticationReducer.userDetails,
    teamVoucherOrder: state.teamVoucherReducer.order,
    teamVoucherPayInfo: state.teamVoucherReducer.payInfo,
    teamVoucherCampaignRateCC: state.teamVoucherReducer.campaignRateCC,
    messageError: state.checkoutReducer.messageError,
    addresses: state.menuReducer.addresses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getRealexConfig: realexConfigRequestDTO =>
      dispatch(getRealexConfig(realexConfigRequestDTO)),
    getStripeConfig: stripeConfigRequestDTO =>
      dispatch(getStripeConfig(stripeConfigRequestDTO)),
    loopCheckingPaymentResponse: idOrder =>
      dispatch(loopCheckingPaymentResponse(idOrder)),
    checkoutResetState: () => dispatch(checkoutResetState()),
    openModalError: () => dispatch(openModalError()),
    openModalReceipt: () => dispatch(openModalReceipt()),
    closeModalError: history => dispatch(closeModalError(history)),
    closeModalPlaceOrderAndRedirect: history =>
      dispatch(closeModalPlaceOrderAndRedirect(history)),
    closeModalReceiptAndRedirect: history =>
      dispatch(closeModalReceiptAndRedirect(history)),
    resizeRealexForm: size => dispatch(resizeRealexForm(size)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Checkout)
);



// WEBPACK FOOTER //
// ./src/containers/Checkout/index.js